import { css } from '@emotion/react'

import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'

import Input from '@src/components/inputs/Input'
import type { ProductVariantOptionsType } from '@src/type/product/form'
import { useEffect, useMemo } from 'react'

type PropsType = {
	horizOption: ProductVariantOptionsType
	vertOption?: ProductVariantOptionsType
	itemIndex: number
}
const SkuTableItem = ({ horizOption, vertOption, itemIndex }: PropsType) => {
	const { getSkuTableItemProps } = useMyProductFormContext()
	const { getFieldProps, setValue, getValues } = getSkuTableItemProps()
	const ItemCno = useMemo(() => {
		if (vertOption?.cno) {
			return [horizOption.cno, vertOption.cno]
		}
		return [horizOption.cno]
	}, [horizOption.cno, vertOption?.cno])

	useEffect(() => {
		setValue(`productSkus.${itemIndex}.cno`, ItemCno)
	}, [ItemCno, itemIndex, setValue])
	const targetSku = getValues(`productSkus.${itemIndex}`)
	return (
		<div>
			<Input
				type="number"
				{...getFieldProps(`productSkus.${itemIndex}.price`)}
				min="0"
				label="판매가"
				wrapperStyle={wrapperStyle}
				labelStyle={labelStyle}
				errorStyle={errorStyle}
			/>
			<Input
				type="number"
				{...getFieldProps(`productSkus.${itemIndex}.challengePrice`)}
				min="0"
				label="챌린지 성공 시, 할인가"
				wrapperStyle={wrapperStyle}
				labelStyle={labelStyle}
				errorStyle={errorStyle}
			/>
			<Input
				type="checkbox"
				{...getFieldProps(`productSkus.${itemIndex}.stockExist`)}
				label="재고 수량 설정"
				wrapperStyle={checkBoxWrapperStyle}
				labelStyle={labelStyle}
			/>
			<Input
				type="number"
				{...getFieldProps(`productSkus.${itemIndex}.stock`)}
				min="0"
				wrapperStyle={wrapperStyle}
				labelStyle={labelStyle}
				disabled={!targetSku?.stockExist}
			/>
		</div>
	)
}

const wrapperStyle = css`
	flex-direction: column;
	width: 100%;
	position: relative;
`

const checkBoxWrapperStyle = css`
	flex-direction: row-reverse;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	padding-bottom: 0;
`

const labelStyle = css`
	width: 100%;
	font-size: 1.2rem;
	height: 3rem;
`
const errorStyle = css`
	position: absolute;
`

export default SkuTableItem
